// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import App from './App';
import Vue from 'vue';
import router from './router';
import moment from 'moment';
import 'bootstrap-sass/assets/javascripts/bootstrap.js';

Vue.config.productionTip = false;

Vue.component('PrimaryAttorneyDisplay', require('./components/PrimaryAttorneyDisplay.vue'));
/* eslint-disable no-new */

new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: {
        App
    }
});

Vue.filter('formatDate', function (val) {
    if (val) {
        return moment(String(val)).format('MM/DD/YYYY');
    }
});



// WEBPACK FOOTER //
// ./src/main.js